module.exports = __webpack_public_path__ + "img/矩形 815@2x.658f96de.png";